import { useEffect } from 'react';
import Gallery from './Gallery';

export default function PhotoGalleryPage() {
  useEffect(() => {
    const title = 'Photo gallery | Turtle Island Cottage';
    const description =
      'Explore photos of Turtle Island Cottage, Hotel Lake, local wildlife, sunsets, and northern lights in Garden Bay, BC.';
    const url = 'https://turtleislandcottage.com/photos/';
    document.title = title;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
    const metadata = {
      'meta[name="description"]': description,
      'meta[property="og:title"]': title,
      'meta[name="twitter:title"]': title,
      'meta[property="og:description"]': description,
      'meta[name="twitter:description"]': description,
      'meta[property="og:url"]': url,
      'meta[property="og:type"]': 'website'
    };
    Object.entries(metadata).forEach(([selector, content]) => {
      document.querySelector(selector)?.setAttribute('content', content);
    });
  }, []);

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:block focus:p-4"
      >
        Skip to content
      </a>
      <header className="border-b border-forest/10 bg-birch">
        <nav
          aria-label="Gallery navigation"
          className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-4 py-5"
        >
          <a
            href="/"
            className="font-display text-xl font-semibold italic text-forest"
          >
            Turtle Island Cottage
          </a>
          <a
            href="/#contact"
            className="text-sm font-semibold text-forest underline underline-offset-4"
          >
            Ask about a stay
          </a>
        </nav>
      </header>
      <main id="main-content">
        <div className="mx-auto max-w-6xl px-4 py-12 sm:py-16">
          <h1 className="font-display text-4xl font-semibold leading-tight text-forest sm:text-6xl">
            Photo gallery
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-bark/75">
            A little closer to lake life. Explore the waterfront, watch the sky
            change, and meet a few of our wild neighbours.
          </p>
        </div>
        <section
          aria-label="Cottage photos"
          className="mx-auto max-w-6xl px-4 pb-16"
        >
          <Gallery fullPage />
        </section>
      </main>
    </>
  );
}
